import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {_ as _extends_1, o as objectWithoutPropertiesLoose, c as esm, e as esm$1} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "../../common/index-877ea290.js";
import {r as require$$3} from "../../common/clsx.m-5dc7436b.js";
import {c as core} from "../../common/index-0a000c27.js";
import {u as useThemeProps_1, s as styled_1} from "../../common/useThemeProps-ef190a94.js";
import {u as useTheme_1} from "../../common/useTheme-ad5c2c5a.js";
import {B as ButtonBase} from "../../common/index-ef2a811c.js";
import {c as capitalize} from "../../common/capitalize-0607751a.js";
import {F as FirstPage, L as LastPage} from "../../common/LastPage-8765bcac.js";
import {c as createSvgIcon_1} from "../../common/createSvgIcon-ee034812.js";
import _jsxRuntime from "react/jsx-runtime";
import "../../common/capitalize-c580b26a.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
import "../../common/useForkRef-b591be37.js";
import "../../common/useEventCallback-f6be53c8.js";
import "../../common/useIsFocusVisible-28d126d4.js";
import "../../common/index-639d8dc8.js";
import "../../common/Transition-8cd86cbd.js";
var paginationClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getPaginationUtilityClass = getPaginationUtilityClass;
  function getPaginationUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiPagination", slot);
  }
  const paginationClasses = (0, core.generateUtilityClasses)("MuiPagination", ["root", "ul", "outlined", "text"]);
  var _default = paginationClasses;
  exports.default = _default;
});
var usePagination_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = usePagination2;
  var _extends2 = interopRequireDefault(_extends_1);
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  const _excluded = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
  function usePagination2(props = {}) {
    const {
      boundaryCount = 1,
      componentName = "usePagination",
      count = 1,
      defaultPage = 1,
      disabled = false,
      hideNextButton = false,
      hidePrevButton = false,
      onChange: handleChange,
      page: pageProp,
      showFirstButton = false,
      showLastButton = false,
      siblingCount = 1
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const [page, setPageState] = (0, esm.unstable_useControlled)({
      controlled: pageProp,
      default: defaultPage,
      name: componentName,
      state: "page"
    });
    const handleClick = (event, value) => {
      if (!pageProp) {
        setPageState(value);
      }
      if (handleChange) {
        handleChange(event, value);
      }
    };
    const range = (start, end) => {
      const length = end - start + 1;
      return Array.from({
        length
      }, (_, i) => start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(page - siblingCount, count - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2), endPages.length > 0 ? endPages[0] - 2 : count - 1);
    const itemList = [
      ...showFirstButton ? ["first"] : [],
      ...hidePrevButton ? [] : ["previous"],
      ...startPages,
      ...siblingsStart > boundaryCount + 2 ? ["start-ellipsis"] : boundaryCount + 1 < count - boundaryCount ? [boundaryCount + 1] : [],
      ...range(siblingsStart, siblingsEnd),
      ...siblingsEnd < count - boundaryCount - 1 ? ["end-ellipsis"] : count - boundaryCount > boundaryCount ? [count - boundaryCount] : [],
      ...endPages,
      ...hideNextButton ? [] : ["next"],
      ...showLastButton ? ["last"] : []
    ];
    const buttonPage = (type) => {
      switch (type) {
        case "first":
          return 1;
        case "previous":
          return page - 1;
        case "next":
          return page + 1;
        case "last":
          return count;
        default:
          return null;
      }
    };
    const items = itemList.map((item) => {
      return typeof item === "number" ? {
        onClick: (event) => {
          handleClick(event, item);
        },
        type: "page",
        page: item,
        selected: item === page,
        disabled,
        "aria-current": item === page ? "true" : void 0
      } : {
        onClick: (event) => {
          handleClick(event, buttonPage(item));
        },
        type: item,
        page: buttonPage(item),
        selected: false,
        disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
      };
    });
    return (0, _extends2.default)({
      items
    }, other);
  }
});
var usePagination = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _usePagination.default;
    }
  });
  var _usePagination = interopRequireDefault(usePagination_1);
});
var paginationItemClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getPaginationItemUtilityClass = getPaginationItemUtilityClass;
  function getPaginationItemUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiPaginationItem", slot);
  }
  const paginationItemClasses = (0, core.generateUtilityClasses)("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon"]);
  var _default = paginationItemClasses;
  exports.default = _default;
});
var NavigateBefore = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var React$1 = _interopRequireWildcard(React);
  var _createSvgIcon = interopRequireDefault(createSvgIcon_1);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  }), "NavigateBefore");
  exports.default = _default;
});
var NavigateNext = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var React$1 = _interopRequireWildcard(React);
  var _createSvgIcon = interopRequireDefault(createSvgIcon_1);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }), "NavigateNext");
  exports.default = _default;
});
var PaginationItem_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _paginationItemClasses = _interopRequireWildcard(paginationItemClasses_1);
  var _useTheme = interopRequireDefault(useTheme_1);
  var _ButtonBase = interopRequireDefault(ButtonBase);
  var _capitalize = interopRequireDefault(capitalize);
  var _FirstPage = interopRequireDefault(FirstPage);
  var _LastPage = interopRequireDefault(LastPage);
  var _NavigateBefore = interopRequireDefault(NavigateBefore);
  var _NavigateNext = interopRequireDefault(NavigateNext);
  var _styled = interopRequireDefault(styled_1);
  const _excluded = ["className", "color", "component", "disabled", "page", "selected", "shape", "size", "type", "variant"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const overridesResolver = (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`size${(0, _capitalize.default)(ownerState.size)}`], ownerState.variant === "text" && styles[`text${(0, _capitalize.default)(ownerState.color)}`], ownerState.variant === "outlined" && styles[`outlined${(0, _capitalize.default)(ownerState.color)}`], ownerState.shape === "rounded" && styles.rounded, ownerState.type === "page" && styles.page, (ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis, (ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext, (ownerState.type === "first" || ownerState.type === "last") && styles.firstLast];
  };
  const useUtilityClasses = (ownerState) => {
    const {
      classes,
      color,
      disabled,
      selected,
      size,
      shape,
      type,
      variant
    } = ownerState;
    const slots = {
      root: ["root", `size${(0, _capitalize.default)(size)}`, variant, shape, color !== "standard" && `${variant}${(0, _capitalize.default)(color)}`, disabled && "disabled", selected && "selected", {
        page: "page",
        first: "firstLast",
        last: "firstLast",
        "start-ellipsis": "ellipsis",
        "end-ellipsis": "ellipsis",
        previous: "previousNext",
        next: "previousNext"
      }[type]],
      icon: ["icon"]
    };
    return (0, core.unstable_composeClasses)(slots, _paginationItemClasses.getPaginationItemUtilityClass, classes);
  };
  const PaginationItemEllipsis = (0, _styled.default)("div", {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({}, theme.typography.body2, {
    borderRadius: 32 / 2,
    textAlign: "center",
    boxSizing: "border-box",
    minWidth: 32,
    padding: "0 6px",
    margin: "0 3px",
    color: theme.palette.text.primary,
    height: "auto",
    [`&.${_paginationItemClasses.default.disabled}`]: {
      opacity: theme.palette.action.disabledOpacity
    }
  }, ownerState.size === "small" && {
    minWidth: 26,
    borderRadius: 26 / 2,
    margin: "0 1px",
    padding: "0 4px"
  }, ownerState.size === "large" && {
    minWidth: 40,
    borderRadius: 40 / 2,
    padding: "0 10px",
    fontSize: theme.typography.pxToRem(15)
  }));
  const PaginationItemPage = (0, _styled.default)(_ButtonBase.default, {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({}, theme.typography.body2, {
    borderRadius: 32 / 2,
    textAlign: "center",
    boxSizing: "border-box",
    minWidth: 32,
    height: 32,
    padding: "0 6px",
    margin: "0 3px",
    color: theme.palette.text.primary,
    [`&.${_paginationItemClasses.default.focusVisible}`]: {
      backgroundColor: theme.palette.action.focus
    },
    [`&.${_paginationItemClasses.default.disabled}`]: {
      opacity: theme.palette.action.disabledOpacity
    },
    transition: theme.transitions.create(["color", "background-color"], {
      duration: theme.transitions.duration.short
    }),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${_paginationItemClasses.default.selected}`]: {
      backgroundColor: theme.palette.action.selected,
      "&:hover": {
        backgroundColor: (0, esm$1.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
        "@media (hover: none)": {
          backgroundColor: theme.palette.action.selected
        }
      },
      [`&.${_paginationItemClasses.default.focusVisible}`]: {
        backgroundColor: (0, esm$1.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
      },
      [`&.${_paginationItemClasses.default.disabled}`]: {
        opacity: 1,
        color: theme.palette.action.disabled,
        backgroundColor: theme.palette.action.selected
      }
    }
  }, ownerState.size === "small" && {
    minWidth: 26,
    height: 26,
    borderRadius: 26 / 2,
    margin: "0 1px",
    padding: "0 4px"
  }, ownerState.size === "large" && {
    minWidth: 40,
    height: 40,
    borderRadius: 40 / 2,
    padding: "0 10px",
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.shape === "rounded" && {
    borderRadius: theme.shape.borderRadius
  }), ({
    theme,
    ownerState
  }) => (0, _extends2.default)({}, ownerState.variant === "text" && {
    [`&.${_paginationItemClasses.default.selected}`]: (0, _extends2.default)({}, ownerState.color !== "standard" && {
      color: theme.palette[ownerState.color].contrastText,
      backgroundColor: theme.palette[ownerState.color].main,
      "&:hover": {
        backgroundColor: theme.palette[ownerState.color].dark,
        "@media (hover: none)": {
          backgroundColor: theme.palette[ownerState.color].main
        }
      },
      [`&.${_paginationItemClasses.default.focusVisible}`]: {
        backgroundColor: theme.palette[ownerState.color].dark
      }
    }, {
      [`&.${_paginationItemClasses.default.disabled}`]: {
        color: theme.palette.action.disabled
      }
    })
  }, ownerState.variant === "outlined" && {
    border: `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${_paginationItemClasses.default.selected}`]: (0, _extends2.default)({}, ownerState.color !== "standard" && {
      color: theme.palette[ownerState.color].main,
      border: `1px solid ${(0, esm$1.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
      backgroundColor: (0, esm$1.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
      "&:hover": {
        backgroundColor: (0, esm$1.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      [`&.${_paginationItemClasses.default.focusVisible}`]: {
        backgroundColor: (0, esm$1.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
      }
    }, {
      [`&.${_paginationItemClasses.default.disabled}`]: {
        borderColor: theme.palette.action.disabledBackground,
        color: theme.palette.action.disabled
      }
    })
  }));
  const PaginationItemPageIcon = (0, _styled.default)("div", {
    name: "MuiPaginationItem",
    slot: "Icon",
    overridesResolver: (props, styles) => styles.icon
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({
    fontSize: theme.typography.pxToRem(20),
    margin: "0 -8px"
  }, ownerState.size === "small" && {
    fontSize: theme.typography.pxToRem(18)
  }, ownerState.size === "large" && {
    fontSize: theme.typography.pxToRem(22)
  }));
  const PaginationItem2 = /* @__PURE__ */ React$1.forwardRef(function PaginationItem3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiPaginationItem"
    });
    const {
      className,
      color = "standard",
      component,
      disabled = false,
      page,
      selected = false,
      shape = "circular",
      size = "medium",
      type = "page",
      variant = "text"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = (0, _extends2.default)({}, props, {
      color,
      disabled,
      selected,
      shape,
      size,
      type,
      variant
    });
    const theme = (0, _useTheme.default)();
    const classes = useUtilityClasses(ownerState);
    const normalizedIcons = theme.direction === "rtl" ? {
      previous: _NavigateNext.default,
      next: _NavigateBefore.default,
      last: _FirstPage.default,
      first: _LastPage.default
    } : {
      previous: _NavigateBefore.default,
      next: _NavigateNext.default,
      first: _FirstPage.default,
      last: _LastPage.default
    };
    const Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(PaginationItemEllipsis, {
      ref,
      ownerState,
      className: (0, _clsx.default)(classes.root, className),
      children: "…"
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)(PaginationItemPage, (0, _extends2.default)({
      ref,
      ownerState,
      component,
      disabled,
      className: (0, _clsx.default)(classes.root, className)
    }, other, {
      children: [type === "page" && page, Icon ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(PaginationItemPageIcon, {
        as: Icon,
        ownerState,
        className: classes.icon
      }) : null]
    }));
  });
  var _default = PaginationItem2;
  exports.default = _default;
});
var PaginationItem = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    paginationItemClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _PaginationItem.default;
    }
  });
  Object.defineProperty(exports, "paginationItemClasses", {
    enumerable: true,
    get: function() {
      return _paginationItemClasses.default;
    }
  });
  var _PaginationItem = interopRequireDefault(PaginationItem_1);
  var _paginationItemClasses = _interopRequireWildcard(paginationItemClasses_1);
  Object.keys(_paginationItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _paginationItemClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _paginationItemClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var Pagination_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _usePagination = interopRequireDefault(usePagination);
  var _PaginationItem = interopRequireDefault(PaginationItem);
  var _styled = interopRequireDefault(styled_1);
  const _excluded = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes,
      variant
    } = ownerState;
    const slots = {
      root: ["root", variant],
      ul: ["ul"]
    };
    return (0, core.unstable_composeClasses)(slots, paginationClasses_1.getPaginationUtilityClass, classes);
  };
  const PaginationRoot = (0, _styled.default)("nav", {
    name: "MuiPagination",
    slot: "Root",
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [styles.root, styles[ownerState.variant]];
    }
  })({});
  const PaginationUl = (0, _styled.default)("ul", {
    name: "MuiPagination",
    slot: "Ul",
    overridesResolver: (props, styles) => styles.ul
  })({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
  });
  function defaultGetAriaLabel(type, page, selected) {
    if (type === "page") {
      return `${selected ? "" : "Go to "}page ${page}`;
    }
    return `Go to ${type} page`;
  }
  const Pagination2 = /* @__PURE__ */ React$1.forwardRef(function Pagination3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiPagination"
    });
    const {
      boundaryCount = 1,
      className,
      color = "standard",
      count = 1,
      defaultPage = 1,
      disabled = false,
      getItemAriaLabel = defaultGetAriaLabel,
      hideNextButton = false,
      hidePrevButton = false,
      renderItem = (item) => /* @__PURE__ */ (0, _jsxRuntime.jsx)(_PaginationItem.default, (0, _extends2.default)({}, item)),
      shape = "circular",
      showFirstButton = false,
      showLastButton = false,
      siblingCount = 1,
      size = "medium",
      variant = "text"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const {
      items
    } = (0, _usePagination.default)((0, _extends2.default)({}, props, {
      componentName: "Pagination"
    }));
    const ownerState = (0, _extends2.default)({}, props, {
      boundaryCount,
      color,
      count,
      defaultPage,
      disabled,
      getItemAriaLabel,
      hideNextButton,
      hidePrevButton,
      renderItem,
      shape,
      showFirstButton,
      showLastButton,
      siblingCount,
      size,
      variant
    });
    const classes = useUtilityClasses(ownerState);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PaginationRoot, (0, _extends2.default)({
      "aria-label": "pagination navigation",
      className: (0, _clsx.default)(classes.root, className),
      ownerState,
      ref
    }, other, {
      children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(PaginationUl, {
        className: classes.ul,
        ownerState,
        children: items.map((item, index) => /* @__PURE__ */ (0, _jsxRuntime.jsx)("li", {
          children: renderItem((0, _extends2.default)({}, item, {
            color,
            "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
            shape,
            size,
            variant
          }))
        }, index))
      })
    }));
  });
  var _default = Pagination2;
  exports.default = _default;
});
var Pagination = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    paginationClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _Pagination.default;
    }
  });
  Object.defineProperty(exports, "paginationClasses", {
    enumerable: true,
    get: function() {
      return _paginationClasses.default;
    }
  });
  var _Pagination = interopRequireDefault(Pagination_1);
  var _paginationClasses = _interopRequireWildcard(paginationClasses_1);
  Object.keys(_paginationClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _paginationClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _paginationClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(Pagination);
export default __pika_web_default_export_for_treeshaking__;
